var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import withStyles from '@fil-react-components/with-styles';
import StreamlineIcon from '@fil-react-components/streamline-icon';
import styles from './BaseButton.style';
/* eslint react/button-has-type: off */
const BaseButton = (_a) => {
    var { ariaLabel, className, children = 'submit', icon, iconSize, block, small, fullWidth, expanded, iconPosition = 'right', svgIcon, svgSize = 20, underline, component: Component = 'button', smallSvgSize = 16, underlineOnHover, dark, isExternal, type = 'button' } = _a, extraProps = __rest(_a, ["ariaLabel", "className", "children", "icon", "iconSize", "block", "small", "fullWidth", "expanded", "iconPosition", "svgIcon", "svgSize", "underline", "component", "smallSvgSize", "underlineOnHover", "dark", "isExternal", "type"]);
    return (
    // @ts-ignore
    _jsxs(Component, Object.assign({ "aria-label": ariaLabel, className: classnames(className, 'fil-button inline-flex align-middle align-center'), type: type }, extraProps, { children: [svgIcon && iconPosition === 'left' && (_jsx(StreamlineIcon, { icon: svgIcon, size: small ? smallSvgSize : svgSize, className: "mr-8" })), children, svgIcon && iconPosition === 'right' && (_jsx(StreamlineIcon, { icon: svgIcon, size: small ? smallSvgSize : svgSize, className: "ml-8" }))] })));
};
BaseButton.displayName = 'BaseButton';
const attrs = ({ children }) => ({
    icon: children &&
        children.type &&
        children.type.displayName &&
        children.type.displayName.indexOf('Icon') > -1,
});
export default withStyles(BaseButton, styles, { attrs });
